import { createContext, useContext } from 'react';

/**
 * Provides the DOM element that portalled overlays (tooltips, popovers,
 * dropdowns, drag previews) should render into.
 *
 * In normal mode the value is `null`, which means each overlay falls back to
 * its own default (typically `document.body`).
 *
 * In fullscreen mode the page sets this to the fullscreen wrapper element so
 * that overlays remain visible inside the fullscreen context. The Fullscreen
 * API only displays the fullscreen element and its DOM descendants, so any
 * overlay that portals to `document.body` would be invisible while the view
 * is fullscreened.
 */
const PortalContainerContext = createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

export const usePortalContainer = () => useContext(PortalContainerContext);
